<template>
  <div>
    <d-input
      class="mt-4 text-h6"
      v-model.number="payload.左手握力"
      label="左手握力"
      max="99"
      :option="{ suffix: 'kg' }"
    ></d-input>
    <d-input
      class="mt-4 text-h6"
      v-model.number="payload.右手握力"
      label="右手握力"
      max="99"
      :option="{ suffix: 'kg' }"
    ></d-input>

    <v-btn block x-large class="mt-4 text-h6" color="success" @click="submit"
      >送出</v-btn
    >
    <v-btn block x-large class="mt-8 text-h6" color="error" @click="back"
      >取消</v-btn
    >
  </div>
</template>

<script>
import station from "@/mixins/station";
export default {
  mixins: [station],
  data: () => ({
    payload: {
      左手握力: null,
      右手握力: null,
    },
  }),
};
</script>

<style lang="scss" scoped></style>
